import { render, staticRenderFns } from "./HistoryReport.vue?vue&type=template&id=5a3c9b43&scoped=true&"
import script from "./HistoryReport.vue?vue&type=script&lang=js&"
export * from "./HistoryReport.vue?vue&type=script&lang=js&"
import style0 from "./HistoryReport.vue?vue&type=style&index=0&id=5a3c9b43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c9b43",
  null
  
)

export default component.exports